import type { SimModel } from "./simulator-model";

export type SliderState = {
  taskIndex: number;
  detailIndex: number;
};

export type SliderChange =
  { kind: "task"; value: number } | { kind: "detail"; value: number };

function clamp(value: number, min: number, max: number): number {
  if (Number.isNaN(value)) return min;
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

export const INITIAL_SLIDER_STATE: SliderState = {
  taskIndex: 0,
  detailIndex: 0,
};

// New task may have fewer picks than the previous one, so detail resets to 0.
export function nextSliderState(
  model: Pick<SimModel, "tasks">,
  prev: SliderState,
  change: SliderChange,
): SliderState {
  const taskMax = Math.max(model.tasks.length - 1, 0);
  if (change.kind === "task") {
    return { taskIndex: clamp(change.value, 0, taskMax), detailIndex: 0 };
  }
  const detailMax = Math.max(
    (model.tasks[prev.taskIndex]?.picks.length ?? 1) - 1,
    0,
  );
  return { ...prev, detailIndex: clamp(change.value, 0, detailMax) };
}
